module.exports = require("/tmp/build_62e6ba86/src/lib/gatsby/gatsby-browser.tsx");